/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getWaitTimeEstimate} from '../api'

 export const useQueryGetWaitTimeEstimate = createReactQueryHook('getWaitTimeEstimate', getWaitTimeEstimate)
